const set = [
    {
        key: "0",
        title: "View"
    },
    {
        key: "1",
        title: "Add"
    },
    {
        key: "2",
        title: "Update"
    },
    {
        key: "3",
        title: "Delete"
    },
    {
        key: "4",
        title: "Bulk upload"
    },
    {
        key: "5",
        title: "Bulk Download"
    },
    {
        key: "6",
        title: "view History"

    },
    {
        key: "7",
        title: "ReUpload Batch History"
    },
]
export default set
export const setObj = {}
set.map((item, index) => {
    setObj[item?.title?.split(" ").join("").toLocaleLowerCase()] = item
})





// 'view', "add", 'update', "delete", "bulk_update", "bulk_download", "upload History"